import {Button, Form, FormInput, Header, Icon} from 'semantic-ui-react'
import React from 'react'
import Fragment from 'react-dot-fragment'
import {Field, formValues} from 'redux-form'
import {I18n} from 'lib/i18n'
import {FormCheckbox} from '../../shared/Forms/ReduxForm'
import Dropzone from 'react-dropzone';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {clearCreatedMedia, createMedium} from 'redux/media'
import config from 'config/config'
import placeholder from 'images/placeholder.png'
import placeholder_inverted from 'images/placeholder_inverted.png'

const i18nkey = 'admin.user.'

const mapStateToProps = (state, ownProps) => {
    const {
        loadingMedia,
        uploadingMedia,
        singleDropzoneUpload,
        createdMedia,
        media,
    } = state.media
    return {
        loadingMedia,
        uploadingMedia,
        singleDropzoneUpload,
        createdMedia,
        media,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            createMedium,
            clearCreatedMedia,
        },
        dispatch
    )
}

class BOP extends React.Component {
    state = {}

    componentWillReceiveProps (nextProps) {
        const {
            change,
            createdMedia: createdMediaOld,
            clearCreatedMedia,
        } = this.props
        const {
            createdMedia: createdMediaNew,
            singleDropzoneUpload: singleDropzoneUploadNew,
        } = nextProps
        const { uploading } = this.state
        if (!createdMediaOld && createdMediaNew && singleDropzoneUploadNew && uploading) {
            change('terms_asset_id', createdMediaNew[0].id)
            clearCreatedMedia()
            this.setState({uploading: false})
        }
    }

    render() {
        const dark = config.theme.dark
        const {
            change,
            terms_asset_id,
            createMedium,
            media = [],
            uploadingMedia,
            lat,
            lng
        } = this.props

        const mapsUrl = !!lat && !!lng ? `https://www.google.com/maps/search/?api=1&query=${lat}%2C${lng}` : null

        let termsSrc = dark ? placeholder_inverted : placeholder
        if (terms_asset_id) {
            const terms = media.find((asset) => asset.id === terms_asset_id)
            if (terms) {
                termsSrc = config.api_url + terms.original_url
            }
        }

        return (
            <Fragment>
                <Header as="h3" dividing content="BOP-Daten" />
                <Form.Group grouped>
                    <Field
                        name="iban"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.iban')}
                        fluid
                    />
                    <Field
                        name="vat_id"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.vat_id')}
                        fluid
                    />
                    <Field
                        name="alternate_email"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.alternate_email')}
                        fluid
                    />
                    <Field
                        name="lat"
                        type="number"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.lat')}
                        fluid
                    />
                    <Field
                        name="lng"
                        type="number"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.lng')}
                        fluid
                    />
                    {mapsUrl && (<a href={mapsUrl} target='_blank'>Link: Google Maps</a>) }
                    <Field
                        name="dealer_profit"
                        type="number"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.dealer_profit')}
                        fluid
                    />
                    <Field
                        name="maximum_discount"
                        type="number"
                        component={FormInput}
                        label={I18n.t(i18nkey + 'core.maximum_discount')}
                        fluid
                    />
                    <Field
                        component={FormCheckbox}
                        label={I18n.t(i18nkey + 'core.validated_bop')}
                        name="validated_bop"
                    />
                </Form.Group>
                <Header as="h3" dividing content={I18n.t(i18nkey + 'terms')} />
                {terms_asset_id && (<div>{I18n.t(i18nkey + 'terms_available')}</div>)}

                <div className="buttonwrapper-left">
                    <Dropzone
                        onDrop={(accepted) => {
                            this.setState({uploading: true})
                            createMedium(accepted, true)
                            change('terms_asset_id', null)
                        }}
                        style={{}}
                        activeClassName="valid"
                        className="dropZone area"
                        children={
                            <Button
                                primary
                                size="tiny"
                                icon="upload"
                                content={I18n.t('admin.mediaBrowser.' + (terms_asset_id ? 'replace' : 'upload'))}
                                loading={uploadingMedia}
                            />
                        }
                    />
                    {terms_asset_id && (
                        <a
                            className="ui tiny button"
                            role="button"
                            href={termsSrc}
                            target='_blank'
                            download
                        ><Icon name="download" />{I18n.t('download')}</a>
                    )}
                    {terms_asset_id && (
                        <Button
                            color="red"
                            secondary={dark}
                            size="tiny"
                            icon="trash"
                            content={I18n.t('admin.mediaBrowser.delete')}
                            onClick={() => change('terms_asset_id', null)}
                        />
                    )}
                </div>

            </Fragment>
        )
  }
}

BOP = connect(mapStateToProps, mapDispatchToProps)(BOP)
BOP = formValues(
    'terms_asset_id',
    'singleDropzoneUpload',
    'createdMedia',
    'media',
    'lat',
    'lng'
)(BOP)

export default BOP



// WEBPACK FOOTER //
// ./src/components/admin/Users/BOP.jsx